enum EFileErrorType {
  MAX_SIZE = 'invalidFileSize',
  MIN_SIZE = 'noZeroFileSize',
  NAME = 'invalidFileName',
  MIME_TYPE = 'invalidFileMimeType',
  LOAD = 'loadError',
}

export default EFileErrorType;
